import { Link } from 'react-router-dom';
import Layout from '@/components/feature/Layout';
import { useTranslation } from 'react-i18next';

export default function NotFound() {
    const { t } = useTranslation();
    return (
        <Layout>
            <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4 py-32">
                <div className="w-20 h-20 bg-primary-100 rounded-2xl flex items-center justify-center mx-auto mb-6">
                    <i className="ri-error-warning-line text-primary-600 text-3xl w-10 h-10 flex items-center justify-center"></i>
                </div>
                <div className="text-7xl font-bold font-heading text-primary-500 mb-4">404</div>
                <h2 className="text-2xl font-semibold font-heading text-foreground-950 mb-4">{t('notFound.title')}</h2>
                <p className="text-foreground-500 mb-8 max-w-md">
                    {t('notFound.description')}
                </p>
                <Link
                    to="/"
                    className="inline-flex items-center gap-2 bg-background-950 hover:bg-background-800 text-white px-6 py-3 rounded-full font-semibold transition-all cursor-pointer whitespace-nowrap"
                >
                    <i className="ri-home-line w-5 h-5 flex items-center justify-center"></i>
                    {t('notFound.backHome')}
                </Link>
            </div>
        </Layout>
    );
}